.placeholder {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: 1.6rem 2.4rem;
  background-color: rgb(var(--color-white-rgb), 0.6);
  border-radius: 2.4rem;
}

.placeholderTitle {
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 1.6;
}

.placeholderText {
  min-height: 1.6em;
  color: var(--color-semantic-text-neutral30);
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6;
}

.circles {
  position: relative;
  width: 8rem;
  height: 8rem;
  margin-right: 2.4rem;
}

.circle {
  position: absolute;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.lightCircle {
  top: 34.66%;
  right: 34.66%;
  bottom: 16.25%;
  left: 16.25%;
  background: var(--color-fantasy);
}

.darkCircle {
  top: 16.25%;
  right: 16.25%;
  bottom: 35.28%;
  left: 35.28%;
  background: var(--color-bittersweet);
  opacity: 0.4;
}
